import Vue from 'vue';
import Component from 'vue-class-component';
import { Viewport } from '../../models/Viewport';
import { ProductSection, Product, ProductGroup } from '../../models/ProductModels';
import ProductSubsectionComponent from './ProductSubsectionComponent.vue';

@Component({
    props: {
        sect: {

        },
        viewport: {

        }
    },
    components: {
        'product-subsection': ProductSubsectionComponent
    }
})
export default class ProductSectionComponent extends Vue {
 
    viewport: Viewport;
    sect: ProductSection;


    index: Number;


    constructor() {
        super();
    }


    get productGroups(): ProductGroup[] {
  
        return this.sect.productGroups;
    }

    created() {
       // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$",this.sect)
    }



}